export default {
  rates: {
    aside: {
      title: "Over the duration of your mortgage you can save",
      subtitle: "Compared to the top Banks average rate of {rate} %",
      info_title: "YOUR INFORMATION",
      rate_title: "RATE",
      term_title: "TERM",
      rate_button_variable: "VARIABLE",
      rate_button_fixed: "FIXED",
      term_button_3: "3 YEARS",
      term_button_5: "5 YEARS",
      info_p1: "The best mortgage product is not just about rates.",
      info_p2:
        "Our Mortgage Experts will contact you to review these offers in more detail.",
      cta_call: "TALK TO A MORTGAGE BROKER"
    },
    tooltips: {
      savings: {
        title: "Savings",
        p1:
          "This saving is calculated by comparing the advertised rates from the top-6 Canadian Banks to our best mortgage rate. We assume these rates will be fixed for the duration of the mortgage. We have used a 25-year amortization.",
        p2:
          "The amortization period is the length of time you will take to pay off your mortgage loan. According to the Canadian Association of Accredited Mortgage Professionals, about 60% of mortgages have an amortization up to 25 years."
      },
      rate: {
        title: "Rate",
        p1:
          "About 2/3 of Canadians choose a fixed mortgage, according to the Canadian Association of Accredited Mortgage Professionals.",
        p2: "Opting for a variable rate can lead to better mortgage rates."
      },
      term: {
        title: "Term",
        p1:
          "About 2/3 of Canadians choose a 5 year mortgage, according to the Canadian Association of Accredited Mortgage Professionals."
      },
      offers: {
        title: "Offers",
        p1:
          "These rates assume a strong credit history. Contact our independent Mortgage Brokers to verify that you qualify for these rates. Nesto does not favor any financial institution in comparing rates for users – rates are ordered from best to worst, regardless of the financial institution. The rate comparison tool is not meant to replace advice from mortgage professionals. Nesto encourages users to contact Mortgage Brokers prior to selecting a mortgage product."
      },
      expertRate: {
        title: "Expert Rate",
        p1:
          "In selecting your mortgage product, you should also consider important conditions like: lump-sum pre-payment conditions, monthly pre-payment conditions, penalties for selling before the end of a term, etc. Don’t worry, our Mortgage Experts will translate these terms in plain English!"
      }
    },
    ratesView: {
      best_quote: "BEST QUOTE",
      other_offers: "OTHER OFFERS",
      rate: "RATE",
      monthly_payment: "MONTHLY PAYMENT"
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/en/rates.js